import React, { useEffect } from "react";

import { useTranslation } from "react-i18next";

import BaseLabel from "components/BaseLabel";
import { Drawer } from "components/Drawer";
import SearchEmpty from "components/SearchEmpty";
import Switch from "components/Switch";

import { handleCloseDrawer, handleList } from "./constants";
import {
  ContentList,
  ContentReadAll,
  ContentReadAllLeft,
  ContentReadAllRight,
} from "./styles";

export interface ISystemNotification {
  title: string;
  openDrawer: boolean;
  setOpenDrawer: React.Dispatch<React.SetStateAction<boolean>>;
  listNotifications: Array<any>;
  changeAll: boolean;
  setChangeAll: React.Dispatch<React.SetStateAction<boolean>>;
  setNotificationId: React.Dispatch<React.SetStateAction<number>>;
  labelReadAll: string;
  emptyMessage: string;
  heightBody?: number;
}

export const SystemNotification: React.FC<ISystemNotification> = ({
  openDrawer,
  setOpenDrawer,
  title,
  listNotifications,
  changeAll,
  setChangeAll,
  setNotificationId,
  emptyMessage,
  labelReadAll,
  heightBody = "78vh",
}) => {
  const { t } = useTranslation();

  useEffect(() => {}, [listNotifications]);

  return (
    <Drawer
      id="notificationDrawerDefaultId"
      open={openDrawer}
      title={title}
      onApply={() => {}}
      onClose={() => handleCloseDrawer(setOpenDrawer)}
      applyLabel={t("common.apply")}
      footer="none"
      paddingLeft={20}
      paddingRight={20}
      bodyHeight={heightBody}
    >
      <>
        {listNotifications.length > 0 ? (
          <>
            <ContentReadAll>
              <ContentReadAllRight>
                <BaseLabel fontSize="14px">{labelReadAll}</BaseLabel>
              </ContentReadAllRight>
              <ContentReadAllLeft>
                <Switch
                  dataTest="switch_read_all"
                  onChange={() => setChangeAll(true)}
                  checked={changeAll}
                />
              </ContentReadAllLeft>
            </ContentReadAll>
            <ContentList>
              {handleList(listNotifications, setNotificationId)}
            </ContentList>
          </>
        ) : (
          <SearchEmpty typeIcon="file" textMessage={emptyMessage} />
        )}
      </>
    </Drawer>
  );
};
